import { PostloadedImage } from '@utils/react';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { image, imageAudio } from './atom.image.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ImageContent(props) {
  return /*#__PURE__*/jsxs("div", {
    className: image,
    children: [/*#__PURE__*/jsx(PostloadedImage, {
      src: props.src,
      alt: ""
    }), props.audioSrc && /*#__PURE__*/jsx(CircledAudioPlayer, {
      className: imageAudio,
      src: props.audioSrc
    })]
  });
}

export { ImageContent };
//# sourceMappingURL=atom.image.js.map
